export default {
	"home": "Home",
	"ai": "AI Open Partnership Platform ",
	"deepcam": "Deepcam",
  "experience": "Online Experience",
  "learn": "Learn Center",
	"login": "Login",
	"register": "Register",
	"app": "App",
	"adminapp": "App",
	"device": "Application Device",
  "sdk": "SDK",
  "sdkList":"SDK Lists",
  "sdkFiles":"SDK Files",
	"announcement": "Notice",
	"personal": "User Center",
	"user": "User Management",
	"sdkManagement": "SDK Management",
	"relationship": "Configure Associations",
	"screen": "Fullscreen ",
	"outScreen": "Exit full screen",
  "quit": "Logout",
  "appList": "App list",
  "warrant": "Authorized file list",
	"global": {
		"not": "Not null",
		"rules1": "Password is 6-16 characters without spaces.",
		"rules2": "Incorrect Email format",
		"rules3": "Incorrect mobile phone number format",
		"input2": "Password",
		"input3": "Please enter your password again",
		"input4": "Email",
		"input5": "Mobile Phone",
		"pswDifferent": "Two inconsistent passwords",
		"label1": "Status",
		"on": "Enable",
		"off": "Disable",
		"cancel": "Cancel",
		"confirm": "Confirm",
		"prompt": "Tips",
		"label2": "SDK Name",
		"label3": "SDK Type",
		"label4": "Select",
		"label8": "Created Time",
		"label9": "Updated Time",
		"label10": "Operation",
		"title1": "Edit",
		"title3": "Delete",
		"add": "Add",
		"search": "Search",
		"contactUs": "CONTACT US",
    "copyright": "Deepcam(China)",
     //添加
     "rule4":"Must be an integer",
    "loadFail1": "Upload files in only .txt format",
    "loadFail3": "Upload files in only .rar or .zip format",
    "loadFail4": "The file must be less than 300MB",
     "loadFail2": "Please select a MAC file to upload",
     "err401":"Sorry! You do not have permission to view this page",
     "err404":"Sorry! Your page is missing",
     "err500":"Only god knows what your servers have gone through!",
     "back": "Back to Home",
     "prve":"Back",
     "admin": "Admin",
     "enterprise":"Enterprise User"
	},
	"publicHome": {
		"title1": {
			"title": " Providing AI Services Based On Independent Patent Technology",
			"iconName0": "Face Detection",
			"iconName1": "Face Tracking",
			"iconName2": "Face Matching",
			"iconName3": "Liveness Detection",
			"iconName4": "Age Attribute",
			"iconName5": "Gender Attribute"
		},
		"title2": {
			"title": "We Are Deeply Involved In Many Fields",
			"iconName0": "Smart Buiding",
			"iconName1": "Public Safety",
			"iconName2": "Smart Retailing",
			"iconName3": "Education",
			"iconName4": "Tourism",
			"iconName5": "Intelligent Robot"
		},
		"title3": {
			"title": "Why Deepcam",
			"iconName0": "World-class Team",
			"iconContent0": "We have the world-class team from CMU and other famous universities.",
			"iconName1": "High Accuracy",
			"iconContent1": "Toughened by commercial scenarios，we are improving the accuracy continuously.",
			"iconName2": "High Robust",
			"iconContent2": "Working in even the demanding environments."
		},
		"title4": {
			"title": "OS and Hardware",
			"Windows": "<p>Minimum hardware configuration (Runnable algorithms)</p><p class=\"gray\">Intel® CoreTM i5-2300@2.80GHz Or the same level chip </p><p>Recommended hardware configuration (With good effect)</p><p class=\"gray\">Intel® CoreTMi7-4600U@2.1GHz Or the same level chip</p><p>OS</p><p class=\"gray\">Windows 7 Or above</p>",
			"Android": "<p>Recommended hardware configuration (With good effect)</p><p class=\"gray\">RK3288、RK3399 Or the same level chip</p><p>OS</p><p class=\"gray\">Android 5.0 Or above</p>",
			"Linux": "<p>Minimum hardware configuration (Runnable algorithms)</p><p class=\"gray\">Intel® CoreTM i3-4330 Processor</p><p>Recommended hardware configuration (With good effect)</p><p class=\"gray\">Intel® CoreTM i7-5775R Processor</p><p>OS</p><p class=\"gray\">Ubuntu 14.04 Or above</p>",
			"IOS": "<p>Minimum hardware configuration (Runnable algorithms)</p><p class=\"gray\">Apple A7</p><p>Recommended hardware configuration (With good effect)</p><p class=\"gray\">Apple A9</p><p>OS</p><p class=\"gray\">iOS 8.0 Or above</p>"
		},
		"title5": {
			"title": "AI Open Partnership Platform ",
			"mark": "Free To Join ",
			"join": "JOIN NOW"
		},
		"footer": {
			"followUs": "FOLLOW US",
			"address": "Add",
			"addressDes": "Rm. 401, Building 7, Jinxiu Science Park Wuhe Avenue, Guanhu, Longhua New District Shenzhen, China 518035",
			"phone": "Tel",
			"mail": "Email",
			"sendmail": "SEND",
			"shenzhen": "(Shenzhen)",
			"wuhan": "(Wuhan)"
		}
	},
	"webPage": {
		"login": {
			"input1": "Username 0r Phone Number",
			"input2": "Password",
			"input3": "Remember Me",
			"sub": "Login",
			"goReg": "Register",
			"goHome": "Home"
		},
		"oblivion": {
			"title":"Forgot Password",
			"input1": "Confirm",
			},
		"register": {
			"input1": "Username",
			"input6": "Verification Code",
			"getCode": "Verification Code",
			"sub": "Sign In",
			"golog": "Login",
			"goHome": "Home",
			"rules4": "Incomplete verification code",
			"failCode": "Verification code acquisition failure",
			"confirmPhone": "Please input the correct phone number"
		},
		"app": {
			"label1": "App Name",
			"label4": "Package Name",
			"label5": "Service Term",
			"label6": "Status",
			"label7": "Created Time",
			"title1": "Download SDK",
			"title2": "Check The Device",
			"title3": "Edit Application Information",
			"label10": "Status",
			"note1": "This operation will permanently delete the application. Will you continue?",
			"loadFail": "Please activate the device before downloading it.",
      //添加
      "label2":"Maximum Activation Quantity",
      "label3":"Expiration date"
		},
		"device": {
			"return": "Return",
			"note1": "This operation will permanently delete the device. Will you continue?"
		},
		"sdk": {
			"add": "Creat a new application",
			"title1": "Creat an application ",
			"label1": "App Name",
			"label2": "Package",
			"label3": "Mac File",
			"label4": "Start MAC",
			"label5": "End MAC",
			"label6": "Scenario",
			"label7": "Industry",
			"label8": "Status",
			"input1": "App Name",
			"note": "Such as",
			"select": "Select the file",
			"input2": "Enter The Beginning Of The MAC Range",
			"input3": "Enter The End Of The MAC Range",
			"customize": "Customize"
		},
		"personal": {
			"title1": "Basic Information",
			"title2": "User Name",
			"title3": "UserID",
			"title4": "Phone",
			"title5": "Email",
			"title6": "New Password",
			"title7": "Confirm Password",
			"title8": "Save Changes",
			"label1": "Change Password Or Not?",
			"pswUpdate": "Password has been updated. Please log in again."
		}
	},
	"adminPage": {
		"user": {
			"userType": "Select the user type",
			"label1": " Advanced User",
			"label2": "Enterprise User",
			"input1": "Username",
			"input2": "Phone Number",
			"input3": "Email",
			"label3": "Username",
			"label4": "Phone Number",
			"label5": "Email",
			"label6": "Type",
			"label7": "Status",
			"title2": "Reset Password",
			"title4": "Creat",
			"label11": "User Type",
			"note1": "This action will reset the password. Will you continue?",
			"note2": "This action will permanently delete the user. Will you continue?",
			"reset": "Sucessful to reset the password，default password is 123456",
			"resetFail": "Fail to reset the password",
			"input4": "Enter A Valid Time (month)",
      //添加
      "input5":"Maximum MACS Quantity （up to 85)",
      "input6":"Maximum UserID  Enterprise User Can register",
      "input7": "Maximum App User Can Register",
      "input8": "Maximum UserID Advanced User Can Register",
      "rule2": "Enter integers between 0 and 85.",
      "label8": "Password",
      "label9": "Confirm password",
      "label10": "Valid time",
      "label12": "User quantities",
      "label13": "App quantities",
      "label14": "Mac quantities",
      "label15": "Ordinary users"
    },
    "app": {
      "title": "Creat ",
      "label1": "Package Name",
      "label2": "Quantitys"
    },
    "sdk": {
      "userType": "Select the user",
			"sdkType": "SDK Type",
			"label3": "SDK Encryption",
			"title1": "Edit SDK",
			"title2": "Creat SDK",
      "label5": "SDK Path",
      "label6": "Permanent",
			"label7": "Account Type",
			"note1": "This operation will permanently delete the SDK. Will you continue?",
      "note2": "This operation will permanently delete the SDK files. Will you continue?",
      "label1":"File name",
      "label2":"File address",
      "label4":"Status",
      "text1":"Deleted",
      "text2":"Normal",
		},
		"association": {
			"userType": "User Type",
			"sdkType": "SDK Type",
			"label1": "Username",
			"title1": "Creating account associations with SDK",
			"note1": "This operation will permanently delete the corresponding information between the user and sdk. Will you continue?"
		}
	}
}



// WEBPACK FOOTER //
// ./src/locale/lang/en-US.js